import { IPositions } from "./types";

export class ScrollSaver {
    positions: IPositions = {};
    currentPath: string;

    constructor(currentPath: string) {
        this.currentPath = currentPath;
    }

    private addPosition(path: string, scrollY: number) {
        this.positions[path] = scrollY;
        this.currentPath = path;
    }

    public saveCurrentScroll() {
        const scrollY = window.scrollY;
        this.addPosition(this.currentPath, scrollY);
        return this;
    }

    public setCurrentPath(path: string) {
        this.currentPath = path;
        return this;
    }

    private getPosition(path: string) {
        return this.positions[path] ?? null;
    }

    public scrollForCurrent() {
        const scrollY = this.getPosition(this.currentPath);
        if (scrollY) {
            window.scrollTo(0, scrollY);
            return this;
        }
        window.scrollTo(0, 0);
        return this;
    }
}
